import React, { useState } from 'react'
import styled from 'styled-components/macro';

const SmallLoder = () => {
    return (
        <LoaderContainer>
            <div class="spinner-border" role="status">
                <span class="sr-only"></span>
            </div>
        </LoaderContainer>
    )
}

export default SmallLoder;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: space-around;
`
